import React from "react";
import { AuthorIntroductionCard, StoryCard } from "@quintype/arrow";
import { bool, func, array, object, string } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

import RelatedStoriesBlock from "../../molecules/story-page-items/related-stories-block/index";
import { DfpComponent } from "../../ads/dfp-component";
import SearchForm from "./search-form";
import { getLocalizationConfig } from "../../collection-templates/utils";

import "./list.m.css";
import { staticTexts } from "../../utils/translate";
import { fallbackImageUrl } from "../../../constants";

const List = ({
  stories,
  loadMoreStories,
  showLoadmore,
  authorInfo = null,
  query,
  updateStories,
  sections,
  setparams,
  setSortType,
}) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const lang = get(qtState, ["config", "publisher-attributes", "lang"], "");
  const pageType = get(qtState, ["pageType"], "");
  const localizationObject = getLocalizationConfig(lang);
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));

  let config = {
    localizationConfig: {},
    fallbackImageUrl: fallbackImageUrl,
  };

  const authorIntrCardConfig = {
    enableBio: true,
    enableSocialLinks: true,
  };

  if (pageType === "tag-page") {
    config = {
      localizationConfig: {
        ...localizationObject,
        showAuthor: false,
        showReadTime: false,
      },
      fallbackImageUrl: fallbackImageUrl,
      showSection: false,
    };
    // config.showSection = false,
  } else if (pageType === "author-page") {
    config = {
      localizationConfig: {
        ...localizationObject,
        showAuthor: false,
        showReadTime: false,
      },
      fallbackImageUrl: fallbackImageUrl,
    };
  } else {
    config = {
      localizationConfig: {
        ...localizationObject,
        showAuthor: false,
        showTime: false,
        showReadTime: false,
      },
      fallbackImageUrl: fallbackImageUrl,
      showSection: false,
    };
  }

  return (
    <div styleName="wrapper">
      <div styleName="stories-wrapper">
        {authorInfo && (
          <AuthorIntroductionCard data={authorInfo} config={authorIntrCardConfig} template="smallCircle" />
        )}
        {query && (
          <SearchForm
            query={query}
            updateStories={updateStories}
            sections={sections}
            setparams={setparams}
            setSortType={setSortType}
          />
        )}
        {stories.length === 0 ? (
          <div styleName="no-stories-container">
            <h2 styleName="no-stories-error">Sorry, No stories found</h2>
            <p styleName="no-stories-message">We could not find any related stories in our collection</p>
          </div>
        ) : (
          stories.map((story, index) => {
            return (
              <>
                <StoryCard
                  story={story}
                  config={config}
                  aspectRatio={[[16, 9]]}
                  borderColor="#e43232"
                  isHorizontalWithImageLast
                  key={index}
                />
                {(index + 1) % 4 === 0 && (
                  <DfpComponent
                    adStyleName="ad-slot-size-300x100-leaderboard"
                    className="dfp-ad"
                    id={`${pageType}-ad-${index}`}
                    path={adSlots.story_leader__ad2.ad_unit}
                    size={adSlots.story_leader__ad2.sizes}
                    viewPortSizeMapping={adSlots.story_leader__ad2.view_port_size_mapping}
                  />
                )}
              </>
            );
          })
        )}
        {showLoadmore && (
          <button aria-label="load more button" styleName="load-more-button" onClick={loadMoreStories}>
            {staticTexts(lang).readMoreStoriesButton}
          </button>
        )}
      </div>
      <RelatedStoriesBlock />
    </div>
  );
};

List.propTypes = {
  stories: array,
  loadMoreStories: func,
  showLoadmore: bool,
  authorInfo: object,
  query: string,
  updateStories: func,
  sections: array,
  setparams: func,
  setSortType: func,
  config: object,
};

export default List;
